import * as THREE from "three";
import { Skeleton } from "three";
import { GLTF, GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { getApiHostUrl } from "../settings";
import { Utils } from "./utils";


class ModelManager {
    loader: GLTFLoader;

    SERVERURL = getApiHostUrl() + "resources/products";
    // https://apidev.aixfoam.de/resources/products/sh001mh_sk_V2_20_weissgrau.gltf
    basicGltfPaths: string[];
    basicGltfs: GLTF[];

    constructor() {

        this.basicGltfPaths = [];
        this.basicGltfPaths.push(this.SERVERURL + "/montagekassette.gltf");
        this.basicGltfPaths.push(this.SERVERURL + "/schwingungsduebel.gltf");
        this.basicGltfPaths.push(this.SERVERURL + "/seilsystem_basic.gltf");
        this.basicGltfPaths.push(this.SERVERURL + "/seilsystem_style.gltf");
        this.basicGltfPaths.push(this.SERVERURL + "/schwingungsduebel4.gltf");
        this.basicGltfPaths.push(this.SERVERURL + "/seilsystem_basic4.gltf");
        this.basicGltfPaths.push(this.SERVERURL + "/seilsystem_style4.gltf");
        this.loader = new GLTFLoader();

    }

    public async loadBasicGltfs() {
        this.basicGltfs = [];
        for (var i = 0; i < this.basicGltfPaths.length; i++) {
            var gltf = await this.loadGltf(this.basicGltfPaths[i]);
            this.basicGltfs.push(gltf);
        }
        //   Promise.all(this.basicGlt);
    }


    public async createProductAttachments(product, element, rotation, scene, walls, productgltf): Promise<any> {
        productgltf.userData.attachements = [];
        // Ist das ok so ? Es gibt selbstverständlich dann nur folgende Kombinationen:
        // - Nur "product"
        // - "product" und "mk"
        // - "product, "mk" und "sd"
        // - "product, "mk" und "sb"
        // - "product, "mk" und "ss"
        //        scene.getElementById(productgltf.uuid);

        var walloffset = 0;
        var ceilingoffset = 0;
        if (product.threeDModel.mk) { // Kassette
            walloffset = 2;
            ceilingoffset = 4;
        }
        if (product.threeDModel.sd) { // dübel
            walloffset = 4.5;
            ceilingoffset = 6;
        }
        if (product.threeDModel.sb) { // seil
            ceilingoffset = 24.5;
        }
        if (product.threeDModel.ss) { // seil
            ceilingoffset = 24.5;
        }

        //    for (var i = 0; i < product.elements.length; i++) {
        var el = element;

        if (!this.basicGltfs)
            await this.loadBasicGltfs();

        if (product.threeDModel.mk) {
            try {

                var newsb = this.cloneGltf(this.basicGltfs[0]).scene;
                var wall = walls[el.mountingSurface.index];
                var wallnormal = Utils.wallnormal(wall);
                //   console.log('el.mountingSurface.type', el.mountingSurface.type);
                newsb.position.set(-el.position.z, el.position.y, -el.position.x);
                if (el.mountingSurface.type == "wall") {
                    newsb.position.set(newsb.position.x - wallnormal[0] * walloffset, newsb.position.y, newsb.position.z - wallnormal[1] * walloffset);
                }
                if (el.mountingSurface.type == "ceiling") {
                    newsb.rotateY(Math.PI / 2);
                    newsb.position.set(newsb.position.x, newsb.position.y - ceilingoffset, newsb.position.z);
                    newsb.userData.mountingSurface = "ceiling";
                    newsb.castShadow = false;
                    newsb.traverse(x => x.isMesh ? x.castShadow = false : null);
                }
                // if (el.mountingSurface.type === 'wall') {
                //     angleY = Utils.calcWallRotation(wall);
                // }
                // if (el.mountingSurface.type === 'ceiling') {
                //     angleX = 90 * Math.PI / 180;
                // }

                // Veratz auf der Wand

                if (rotation?.x) newsb.rotateX(rotation.x);
                if (rotation?.y) newsb.rotateY(rotation.y);
                if (rotation?.z) newsb.rotateZ(rotation.z);

                newsb.userData.type = "productattachement";
                scene.add(newsb);
                productgltf.userData.attachements.push(newsb.uuid);
            } catch (err) {
                console.warn(err);
            }
        }


        if (product.threeDModel.sd) { // sd = schwingungsdübel
            var newsb = this.cloneGltf(this.basicGltfs[4]).scene;
            var wall = walls[el.mountingSurface.index];
            var wallnormal = Utils.wallnormal(wall);
            //   console.log('el.mountingSurface.type', el.mountingSurface.type);
            newsb.position.set(-el.position.z, el.position.y, -el.position.x);
            if (el.mountingSurface.type == "wall") {
                newsb.position.set(newsb.position.x - wallnormal[0] * walloffset, newsb.position.y, newsb.position.z - wallnormal[1] * walloffset);
            }
            if (el.mountingSurface.type == "ceiling") {
                newsb.rotateY(Math.PI / 2);
                newsb.position.set(newsb.position.x, newsb.position.y - ceilingoffset, newsb.position.z);
                newsb.userData.mountingSurface = "ceiling";
                newsb.castShadow = false;
                newsb.traverse(x => x.isMesh ? x.castShadow = false : null);


            }
            // if (el.mountingSurface.type === 'wall') {
            //     angleY = Utils.calcWallRotation(wall);
            // }
            // if (el.mountingSurface.type === 'ceiling') {
            //     angleX = 90 * Math.PI / 180;
            // }

            // Versatz auf der Wand

            if (rotation?.x) newsb.rotateX(rotation.x);
            if (rotation?.y) newsb.rotateY(rotation.y);
            if (rotation?.z) newsb.rotateZ(rotation.z);

            newsb.userData.type = "productattachement";
            scene.add(newsb);
            productgltf.userData.attachements.push(newsb.uuid);

            // for (var x = 0; x < 4; x++) {
            //     var newsb = this.cloneGltf(this.basicGltfs[1]).scene;
            //     var wall = walls[el.mountingSurface.index];
            //     var wallnormal = Utils.wallnormal(wall);
            //     //   console.log('el.mountingSurface.type', el.mountingSurface.type);
            //     newsb.position.set(-el.position.z, el.position.y, -el.position.x);
            //     if (el.mountingSurface.type == "wall") {
            //         var tx = 17.65;
            //         var tz = 17.65;
            //         var ty = 36;
            //         if (x == 0)
            //             newsb.position.set(newsb.position.x - wallnormal[0] * walloffset + tx * wallnormal[1], newsb.position.y + ty, newsb.position.z - wallnormal[1] * walloffset + tz * wallnormal[0]);
            //         if (x == 1)
            //             newsb.position.set(newsb.position.x - wallnormal[0] * walloffset - tx * wallnormal[1], newsb.position.y + ty, newsb.position.z - wallnormal[1] * walloffset - tz * wallnormal[0]);
            //         if (x == 2)
            //             newsb.position.set(newsb.position.x - wallnormal[0] * walloffset + tx * wallnormal[1], newsb.position.y - ty, newsb.position.z - wallnormal[1] * walloffset + tz * wallnormal[0]);
            //         if (x == 3)
            //             newsb.position.set(newsb.position.x - wallnormal[0] * walloffset - tx * wallnormal[1], newsb.position.y - ty, newsb.position.z - wallnormal[1] * walloffset - tz * wallnormal[0]);
            //     }
            //     if (el.mountingSurface.type == "ceiling") {
            //         newsb.rotateY(Math.PI / 2);
            //         newsb.position.set(newsb.position.x, newsb.position.y - ceilingoffset, newsb.position.z);

            //         if (el.mountingSurface.type == "ceiling") {
            //             tx = 43;
            //             tz = 16;
            //         }
            //         var ceiloffsetsb = 1;
            //         if (x == 0)
            //             newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
            //         if (x == 1)
            //             newsb.position.set(newsb.position.x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
            //         if (x == 2)
            //             newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);
            //         if (x == 3)
            //             newsb.position.set(newsb.position.x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);

            //     }

            //     if (rotation?.x) newsb.rotateX(rotation.x);
            //     if (rotation?.y) newsb.rotateY(rotation.y);
            //     if (rotation?.z) newsb.rotateZ(rotation.z);
            //     newsb.userData.type = "productattachement";
            //     scene.add(newsb);
            //     productgltf.userData.attachements.push(newsb.uuid);

            //}


        }

        if (product.threeDModel.sb) {
            var newsb = this.cloneGltf(this.basicGltfs[5]).scene;
            var wall = walls[el.mountingSurface.index];
            var wallnormal = Utils.wallnormal(wall);
            //   console.log('el.mountingSurface.type', el.mountingSurface.type);
            newsb.position.set(-el.position.z, el.position.y, -el.position.x);
            if (el.mountingSurface.type == "wall") {
                newsb.position.set(newsb.position.x - wallnormal[0] * walloffset, newsb.position.y, newsb.position.z - wallnormal[1] * walloffset);
            }
            if (el.mountingSurface.type == "ceiling") {
                newsb.rotateY(Math.PI / 2);
                newsb.position.set(newsb.position.x, newsb.position.y - ceilingoffset, newsb.position.z);
                newsb.userData.mountingSurface = "ceiling";
                newsb.castShadow = false;
                newsb.traverse(x => x.isMesh ? x.castShadow = false : null);

            }
            // if (el.mountingSurface.type === 'wall') {
            //     angleY = Utils.calcWallRotation(wall);
            // }
            // if (el.mountingSurface.type === 'ceiling') {
            //     angleX = 90 * Math.PI / 180;
            // }

            // Versatz auf der Wand

            if (rotation?.x) newsb.rotateX(rotation.x);
            if (rotation?.y) newsb.rotateY(rotation.y);
            if (rotation?.z) newsb.rotateZ(rotation.z);

            newsb.userData.type = "productattachement";
            scene.add(newsb);
            productgltf.userData.attachements.push(newsb.uuid);


            // for (var x = 0; x < 4; x++) {

            //     var newsb = this.cloneGltf(this.basicGltfs[2]).scene;
            //     var wall = walls[el.mountingSurface.index];
            //     var wallnormal = Utils.wallnormal(wall);
            //     var ceiloffsetsb = 25;
            //     newsb.position.set(-el.position.z, el.position.y, -el.position.x);
            //     // Veratz auf der Wand
            //     var tx = 16;
            //     var tz = 43;

            //     if (el.mountingSurface.type == "ceiling") {
            //         tx = 43;
            //         tz = 16;
            //     }

            //     if (x == 0)
            //         newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
            //     if (x == 1)
            //         newsb.position.set(newsb.position.x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
            //     if (x == 2)
            //         newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);
            //     if (x == 3)
            //         newsb.position.set(newsb.position.x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);

            //     const box = new THREE.Box3().setFromObject(newsb);
            //     const center = box.getCenter(new THREE.Vector3());
            //     newsb.position.x += (newsb.position.x - center.x);
            //     newsb.position.y += (newsb.position.y - center.y);
            //     newsb.position.z += (newsb.position.z - center.z);
            //     newsb.userData.type = "productattachement";
            //     scene.add(newsb);
            //     productgltf.userData.attachements.push(newsb.uuid);

            // }
        }
        if (product.threeDModel.ss) {  // mit seil
            var newsb = this.cloneGltf(this.basicGltfs[6]).scene;
            var wall = walls[el.mountingSurface.index];
            var wallnormal = Utils.wallnormal(wall);
            //   console.log('el.mountingSurface.type', el.mountingSurface.type);
            newsb.position.set(-el.position.z, el.position.y, -el.position.x);
            if (el.mountingSurface.type == "wall") {
                newsb.position.set(newsb.position.x - wallnormal[0] * walloffset, newsb.position.y, newsb.position.z - wallnormal[1] * walloffset);
            }
            if (el.mountingSurface.type == "ceiling") {
                newsb.rotateY(Math.PI / 2);
                newsb.position.set(newsb.position.x, newsb.position.y - ceilingoffset, newsb.position.z);
                newsb.userData.mountingSurface = "ceiling";
                newsb.castShadow = false;
                newsb.traverse(x => x.isMesh ? x.castShadow = false : null);


            }
            // if (el.mountingSurface.type === 'wall') {
            //     angleY = Utils.calcWallRotation(wall);
            // }
            // if (el.mountingSurface.type === 'ceiling') {
            //     angleX = 90 * Math.PI / 180;
            // }

            // Versatz auf der Wand

            if (rotation?.x) newsb.rotateX(rotation.x);
            if (rotation?.y) newsb.rotateY(rotation.y);
            if (rotation?.z) newsb.rotateZ(rotation.z);

            newsb.userData.type = "productattachement";
            scene.add(newsb);
            productgltf.userData.attachements.push(newsb.uuid);



            //     for (var x = 0; x < 4; x++) {

            //         var newsb = this.cloneGltf(this.basicGltfs[3]).scene;
            //         var wall = walls[el.mountingSurface.index];
            //         var wallnormal = Utils.wallnormal(wall);
            //         var ceiloffsetsb = 25;
            //         newsb.position.set(-el.position.z, el.position.y, -el.position.x);
            //         // Veratz auf der Wand
            //         var tx = 16;
            //         var tz = 43;
            //         if (el.mountingSurface.type == "ceiling") {
            //             tx = 43;
            //             tz = 16;
            //         }


            //         if (x == 0)
            //             newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
            //         if (x == 1)
            //             newsb.position.set(newsb.position.x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
            //         if (x == 2)
            //             newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);
            //         if (x == 3)
            //             newsb.position.set(newsb.position.x + x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);

            //         const box = new THREE.Box3().setFromObject(newsb);
            //         const center = box.getCenter(new THREE.Vector3());
            //         newsb.position.x += (newsb.position.x - center.x);
            //         newsb.position.y += (newsb.position.y - center.y);
            //         newsb.position.z += (newsb.position.z - center.z);
            //         newsb.userData.type = "productattachement";
            //         scene.add(newsb);
            //         productgltf.userData.attachements.push(newsb.uuid);

            //     }
        }

        return { walloffset: walloffset, ceilingoffset: ceilingoffset };

    }


    public async setProductAttachmentPositions(product, element, rotation, scene, walls, productgltf): Promise<any> {
        var walloffset = 0;
        var ceilingoffset = 0;
        if (product.threeDModel.mk) {
            walloffset = 2;
            ceilingoffset = 4;
        }
        if (product.threeDModel.sd) {
            walloffset = 5.5;
            ceilingoffset = 6;
        }
        if (product.threeDModel.sb) {
            ceilingoffset = 32;
        }
        if (product.threeDModel.ss) {
            ceilingoffset = 32;
        }

        //    for (var i = 0; i < product.elements.length; i++) {
        var el = element;

        if (product.threeDModel.mk) {
            var newsb = this.cloneGltf(this.basicGltfs[0]).scene;
            var wall = walls[el.mountingSurface.index];
            var wallnormal = Utils.wallnormal(wall);
            //   console.log('el.mountingSurface.type', el.mountingSurface.type);
            newsb.position.set(-el.position.z, el.position.y, -el.position.x);
            if (el.mountingSurface.type == "wall") {
                newsb.position.set(newsb.position.x - wallnormal[0] * walloffset, newsb.position.y, newsb.position.z - wallnormal[1] * walloffset);
            }
            if (el.mountingSurface.type == "ceiling") {
                newsb.rotateY(Math.PI / 2);
                newsb.position.set(newsb.position.x, newsb.position.y - ceilingoffset, newsb.position.z);
            }
            // if (el.mountingSurface.type === 'wall') {
            //     angleY = Utils.calcWallRotation(wall);
            // }
            // if (el.mountingSurface.type === 'ceiling') {
            //     angleX = 90 * Math.PI / 180;
            // }

            // Veratz auf der Wand

            if (rotation?.x) newsb.rotateX(rotation.x);
            if (rotation?.y) newsb.rotateY(rotation.y);
            if (rotation?.z) newsb.rotateZ(rotation.z);

            newsb.userData.type = "productattachement";
            productgltf.add(newsb);

        }


        if (product.threeDModel.sd) {

            for (var x = 0; x < 4; x++) {
                var newsb = this.cloneGltf(this.basicGltfs[1]).scene;
                var wall = walls[el.mountingSurface.index];
                var wallnormal = Utils.wallnormal(wall);
                //   console.log('el.mountingSurface.type', el.mountingSurface.type);
                newsb.position.set(-el.position.z, el.position.y, -el.position.x);
                if (el.mountingSurface.type == "wall") {
                    var tx = 17.65;
                    var tz = 17.65;
                    var ty = 36;
                    if (x == 0)
                        newsb.position.set(newsb.position.x - wallnormal[0] * walloffset + tx * wallnormal[1], newsb.position.y + ty, newsb.position.z - wallnormal[1] * walloffset + tz * wallnormal[0]);
                    if (x == 1)
                        newsb.position.set(newsb.position.x - wallnormal[0] * walloffset - tx * wallnormal[1], newsb.position.y + ty, newsb.position.z - wallnormal[1] * walloffset - tz * wallnormal[0]);
                    if (x == 2)
                        newsb.position.set(newsb.position.x - wallnormal[0] * walloffset + tx * wallnormal[1], newsb.position.y - ty, newsb.position.z - wallnormal[1] * walloffset + tz * wallnormal[0]);
                    if (x == 3)
                        newsb.position.set(newsb.position.x - wallnormal[0] * walloffset - tx * wallnormal[1], newsb.position.y - ty, newsb.position.z - wallnormal[1] * walloffset - tz * wallnormal[0]);
                }
                if (el.mountingSurface.type == "ceiling") {
                    newsb.rotateY(Math.PI / 2);
                    newsb.position.set(newsb.position.x, newsb.position.y - ceilingoffset, newsb.position.z);

                    if (el.mountingSurface.type == "ceiling") {
                        tx = 43;
                        tz = 16;
                    }
                    var ceiloffsetsb = 1;
                    if (x == 0)
                        newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
                    if (x == 1)
                        newsb.position.set(newsb.position.x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
                    if (x == 2)
                        newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);
                    if (x == 3)
                        newsb.position.set(newsb.position.x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);

                }

                if (rotation?.x) newsb.rotateX(rotation.x);
                if (rotation?.y) newsb.rotateY(rotation.y);
                if (rotation?.z) newsb.rotateZ(rotation.z);
                newsb.userData.type = "productattachement";
                productgltf.add(newsb);
            }


        }

        if (product.threeDModel.sb) {
            for (var x = 0; x < 4; x++) {

                var newsb = this.cloneGltf(this.basicGltfs[2]).scene;
                var wall = walls[el.mountingSurface.index];
                var wallnormal = Utils.wallnormal(wall);
                var ceiloffsetsb = 25;
                newsb.position.set(-el.position.z, el.position.y, -el.position.x);
                // Veratz auf der Wand
                var tx = 16;
                var tz = 43;

                if (el.mountingSurface.type == "ceiling") {
                    tx = 43;
                    tz = 16;
                }

                if (x == 0)
                    newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
                if (x == 1)
                    newsb.position.set(newsb.position.x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
                if (x == 2)
                    newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);
                if (x == 3)
                    newsb.position.set(newsb.position.x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);

                const box = new THREE.Box3().setFromObject(newsb);
                const center = box.getCenter(new THREE.Vector3());
                newsb.position.x += (newsb.position.x - center.x);
                newsb.position.y += (newsb.position.y - center.y);
                newsb.position.z += (newsb.position.z - center.z);
                newsb.userData.type = "productattachement";
                productgltf.add(newsb);
            }
        }
        if (product.threeDModel.ss) {
            for (var x = 0; x < 4; x++) {

                var newsb = this.cloneGltf(this.basicGltfs[3]).scene;
                var wall = walls[el.mountingSurface.index];
                var wallnormal = Utils.wallnormal(wall);
                var ceiloffsetsb = 25;
                newsb.position.set(-el.position.z, el.position.y, -el.position.x);
                // Veratz auf der Wand
                var tx = 16;
                var tz = 43;
                if (el.mountingSurface.type == "ceiling") {
                    tx = 43;
                    tz = 16;
                }


                if (x == 0)
                    newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
                if (x == 1)
                    newsb.position.set(newsb.position.x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z - tz);
                if (x == 2)
                    newsb.position.set(newsb.position.x - tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);
                if (x == 3)
                    newsb.position.set(newsb.position.x + x + tx, newsb.position.y - ceiloffsetsb, newsb.position.z + tz);

                const box = new THREE.Box3().setFromObject(newsb);
                const center = box.getCenter(new THREE.Vector3());
                newsb.position.x += (newsb.position.x - center.x);
                newsb.position.y += (newsb.position.y - center.y);
                newsb.position.z += (newsb.position.z - center.z);
                newsb.userData.type = "productattachement";
                productgltf.add(newsb);
            }
        }

        return { walloffset: walloffset, ceilingoffset: ceilingoffset };

    }
    async loadGltf(filename: string): Promise<GLTF> {

        var gltf = await (this.loader).loadAsync(filename);

        gltf.scene.traverse((child) => {
            if ((child as any).isMesh) {
                (child as any).cursor = 'pointer';
                child.castShadow = true;
            }
            if (child.type == "Object3D") {

            }
        });
        // gltf.scene.position.set(-position.x, position.y, -position.z);
        // gltf.scene.scale.set(scale, scale, scale);
        // if (rotation?.x) gltf.scene.rotateX(rotation.x);
        // if (rotation?.y) gltf.scene.rotateY(rotation.y);
        // if (rotation?.z) gltf.scene.rotateZ(rotation.z);
        gltf.scene.userData.filename = filename;

        return gltf;
    }


    public cloneGltf = (gltf) => {
        const clone = {
            animations: gltf.animations,
            scene: gltf.scene.clone(true)
        };

        const skinnedMeshes = {};

        gltf.scene.traverse(node => {
            if (node.isSkinnedMesh) {
                skinnedMeshes[node.name] = node;
            }
        });

        const cloneBones = {};
        const cloneSkinnedMeshes = {};

        clone.scene.traverse(node => {
            if (node.isBone) {
                cloneBones[node.name] = node;
            }

            if (node.isSkinnedMesh) {
                cloneSkinnedMeshes[node.name] = node;
            }
        });

        for (let name in skinnedMeshes) {
            const skinnedMesh = skinnedMeshes[name];
            const skeleton = skinnedMesh.skeleton;
            const cloneSkinnedMesh = cloneSkinnedMeshes[name];

            const orderedCloneBones = [];

            for (let i = 0; i < skeleton.bones.length; ++i) {
                const cloneBone = cloneBones[skeleton.bones[i].name];
                orderedCloneBones.push(cloneBone);
            }

            cloneSkinnedMesh.bind(
                new Skeleton(orderedCloneBones, skeleton.boneInverses),
                cloneSkinnedMesh.matrixWorld);
        }

        return clone;
    }

}

export { ModelManager };

